import * as tslib_1 from "tslib";
import * as React from 'react';
import { StyledIconBase } from '../../StyledIconBase';
export var Archive = React.forwardRef(function (props, ref) {
    var attrs = {
        "fill": "currentColor",
    };
    return (React.createElement(StyledIconBase, tslib_1.__assign({ iconAttrs: attrs, iconVerticalAlign: "middle", iconViewBox: "0 0 24 24" }, props, { ref: ref }),
        React.createElement("path", { d: "M21.801 6.401l-2.69-3.598A2.011 2.011 0 0 0 17.508 2h-11c-.626 0-1.224.298-1.598.797l-2.709 3.6.014.011A.977.977 0 0 0 2 6.999V18a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V6.999a.975.975 0 0 0-.213-.588l.014-.01zM6.508 4h11l1.496 2H5.003l1.505-2zM17 13v1H7v-4h2v2h6v-2h2v3z", key: "k0" })));
});
Archive.displayName = 'Archive';
export var ArchiveDimensions = { height: 24, width: 24 };
